module.exports = __webpack_public_path__ + "img/Botão.37d0e404.png";